import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllPublicTest = async () => {
  let tests = [];
  try {
    const getAllResponse = await axios.get(
      jsonConfig.apiUrl + "GetAllPublicTest",
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    tests = getAllResponse.data.data;
    return Promise.resolve(tests);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getAllPublicTest;
